import { api } from './client';

/** Подписка браузера на web-push (PWA): ключи — из PushSubscription.toJSON(). Клиента сервер берёт из сессии. */
export interface PushSubscriptionBody {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export interface PushPublicKey {
  publicKey: string;
  /** false — на сервере не заданы VAPID-ключи: подписка невозможна, кнопку не показываем. */
  enabled: boolean;
}

// Все запросы — silent: ошибки показывает экран своими словами (или молчит, как при входе/выходе).
export const pushApi = {
  publicKey: () => api.get<PushPublicKey>('/push/public-key', { silent: true }),
  subscribe: (subscription: PushSubscriptionBody) =>
    api.post<{ saved: boolean }>('/push/subscribe', { subscription }, { silent: true }),
  unsubscribe: (endpoint: string) =>
    api.delete<{ removed: boolean }>('/push/subscribe', { body: JSON.stringify({ endpoint }), silent: true }),
};
